<template>
  <el-dialog
    :title="$t('vie.Pag.Aut.AppPolitics.licenseAgreement')"
    :visible.sync="localShow"
    class="politic-dialog text-left"
    top="3%"
    width="60%"
  >
    <div
      class="row d-flex justify-content-center align-items-center"
      style="padding-right: 20px; padding-left: 20px; font-size: 11px"
    >
      <div v-html="policyDescription"></div>
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="mt-3 text-center">
        <hr />
      </div>
      <div
        v-if="showButton"
        class="row d-flex justify-content-center align-items-center"
      >
        <el-checkbox v-model="isChecked">{{
          $t('vie.Pag.Aut.AppPolitics.termsAndConditions')
        }}</el-checkbox>
      </div>
      <br />
      <div
        row
        v-if="showButton && isChecked"
        class="row d-flex justify-content-center align-items-center"
      >
        <l-button
          type="info"
          class="btn-filter custom-shadow-btn"
          @click="confirmPolitics"
        >
          {{ $t('common_words.confirm') }}
        </l-button>
      </div>
    </span>
  </el-dialog>
</template>
<script>
import { Checkbox } from 'element-ui';
import MixinTranslate from 'src/util/mixinTranslate';

export default {
  components: {
    [Checkbox.name]: Checkbox,
  },

  data() {
    return {
      isChecked: false,
    };
  },
  name: 'AppPolitics',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    policy: {
      type: Object,
      default: () => {},
    },
    showButton: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [MixinTranslate],
  model: {
    prop: 'show',
    event: 'showchange',
  },
  computed: {
    localShow: {
      get: function () {
        return this.show;
      },
      set: function (value) {
        this.$emit('showchange', value);
      },
    },
    policyUrl() {
      if (this.policy) {
        return this.policy.url;
      }
      return '';
    },
    policyDescription() {
      if (this.policy && this.policy.description) {
        return this.translateDataBaseText(
          this.policy.description,
          JSON.stringify({
            en: this.policy.description_en,
            pt_BR: this.policy.description_pt,
          })
        );
      }
      return '';
    },
  },
  methods: {
    confirmPolitics() {
      this.$emit('confirm');
    },

    save() {
      Axios.saveMasters('')
        .then((response1) => {})
        .catch((error) => {});
    },
  },
};
</script>
<style>
.politic-dialog .el-dialog .el-dialog__body {
  height: 50vh;
  overflow-y: overlay;
}
</style>
